<rt-dropdown>
  <rt-dropdown-header [fullWidthTitle]="true">
    {{ 'app.email_templates.placeholder_categories_header' | translate }}
  </rt-dropdown-header>
  <cdk-virtual-scroll-viewport
    #scrollViewport
    itemSize="64"
    class="items-container"
    (scrolledIndexChange)="onScrolledIndexChange()"
    [style.height]="getContainerHeight()"
  >
    <rt-dropdown-item
      *cdkVirtualFor="let el of placeholders(); trackBy: trackByPlaceholder; let index = index"
      [class.highlighted]="index === highlightedIndex"
      (click)="select.emit(el)"
      layout-vertical
    >
      <rt-heading variant="heading">
        <span class="preserve-whitespace" text-primary margin-right-small-xx>[ </span>
        {{ withoutBrackets(el.id) }}
        <span class="preserve-whitespace" text-primary margin-left-small-xx> ]</span>
      </rt-heading>
      <span
        [innerHTML]="el.interpolated ? el.value : el.data.description"
        class="description info-dropdown-text"
      >
      </span>
    </rt-dropdown-item>
  </cdk-virtual-scroll-viewport>
</rt-dropdown>
